import {Tag, Dropdown} from "antd";
import moment from "moment";
import WorklistItemRowMenu from "./WorklistItemRowMenu";
import {getStatusByValue, getStatusLabel, getStatusOptions, getStatusTagColor} from "../../../enums/WorklistItemStatusEnum";
import ApiService from "../../../core/service/api-service";
import {PERMISSIONS, useUser} from "../../../core/context/UserContext";

export default function worklistItemColumns(t, hasPermission, loadData, openScheduleModal, openAppointmentModal)
{
    return [
        {
            title: t('Id'),
            dataIndex: 'id',
            key: 'id',
            columnName: 'id',
            width: 80,
            sorter: true,
            render: (text, row) => (
                <WorklistItemRowMenu row={row}/>
            )
        },
        {
            title: t('Accession Number'),
            dataIndex: 'accessionNumber',
            key: 'accessionNumber',
            columnName: 'accessionNumber',
            sorter: true,
        },
        {
            title: t('Patient Name'),
            dataIndex: 'patientName',
            key: 'patientName',
            render: (text, row) => `${row?.patientName} ${row?.patientLastname}`,
            sorter: true,
        },
        {
            title: t('Patient ID'),
            dataIndex: 'patientId',
            key: 'patientId',
            columnName: 'patientId',
            sorter: true,
        },
        {
            title: t('Request Type'),
            dataIndex: 'requestTypeName',
            key: 'requestTypeName',
            columnName: 'requestType.displayName',
            render: (text, row) => row?.requestType?.displayName,
            sorter: true,
        },
        {
            title: t('Modality'),
            dataIndex: 'modality',
            key: 'modality',
            columnName: 'modality',
            render: (text, row) => row?.modality?.name,
            sorter: true,
        },
        {
            title: t('Hospital'),
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            columnName: 'hospitalName',
            render: (text, row) => row?.hospital?.name || '',
            sorter: true,
        },
        {
            title: t('Device'),
            dataIndex: 'deviceName',
            key: 'deviceName',
            columnName: 'device.name',
            sorter: true,
            render: (text,row) => row?.device?.name
        },
        {
            title: t('Scheduled Start'),
            dataIndex: 'scheduledStartTime',
            key: 'scheduledStartTime',
            columnName: 'scheduledStartTime',
            sorter: true,
            render: (text, row) => {
                if(row?.appointment) {
                    return (
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            if (openAppointmentModal) {
                                openAppointmentModal(row);
                            }
                        }}>
                            {moment(row?.appointment?.scheduledStartTime).format('DD.MM.YYYY HH:mm')}
                        </a>
                    )
                }

                return row?.appointment ? moment(row?.appointment?.scheduledStartTime).format('DD.MM.YYYY HH:mm') : '-'
            }
        },
        {
            title: t('Scheduled End'),
            dataIndex: 'scheduledEndTime',
            key: 'scheduledEndTime',
            columnName: 'scheduledEndTime',
            sorter: true,
            render: (text, row) => row?.appointment ? moment(row?.appointment?.scheduledEndTime).format('DD.MM.YYYY HH:mm') : '-'
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
            columnName: 'status',
            sorter: true,
            render: (text, row) => {
                const status = row?.appointment?.id ? row?.appointment?.status : 0;
                const statusConfig = getStatusByValue(status);
                const label = getStatusLabel(status);
                const color = getStatusTagColor(status);
                
                // Eğer kullanıcının izni yoksa sadece tag göster
                if (!hasPermission || !hasPermission(PERMISSIONS.WORKLIST_STATUS_CHANGE)) {
                    return <Tag color={color}>{t(label)}</Tag>;
                }

                const handleStatusChange = async (newStatus) => {
                    try {
                        const response = await ApiService.Appointment.UpdateStatus({
                            id: row.appointment.id,
                            worklistItemId: row.id,
                            status: newStatus.key
                        });

                        if (response.success && loadData) {
                            loadData();
                        }
                    } catch (error) {
                        console.error('Failed to update appointment status:', error);
                    }
                };

                const handleSchedule = () => {
                    if (openScheduleModal) {
                        openScheduleModal([row]);
                    }
                };

                let menuItems = [];

                if (status === 0) {
                    // Unscheduled durumunda sadece "Schedule" seçeneği
                    menuItems = [{
                        key: 'schedule',
                        label: t('Schedule'),
                        onClick: handleSchedule
                    }];
                } else {
                    // Scheduled/Accepted/Cancelled durumlarında diğer statülere geçiş + unscheduled
                    menuItems = getStatusOptions()
                        .filter(option => option.value !== status)
                        .map(option => ({
                            key: option.value,
                            label: t(option.label),
                            onClick: handleStatusChange
                        }));
                }

                return (
                    <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                        <Tag color={color} style={{ cursor: 'pointer' }}>
                            {t(label)}
                        </Tag>
                    </Dropdown>
                );
            }
        },
        {
            title: t('Created At'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            columnName: 'createdAt',
            sorter: true,
            render: (text) => moment(text).format('DD.MM.YYYY HH:mm')
        },
    ];
}
